import React from "react";
import PropTypes from "prop-types";
import { CreateContainer } from "../../../Containers/ContainerCreate";
import { getChimneyProfileTracks } from "../../../api/getChimneyProfile";
import Spinner from "react-bootstrap/Spinner";

class ChimneyProfileTracksContainer extends React.Component {
  componentDidMount() {
    const { chimDir, page } = this.props;
    this.props.request(chimDir, page);
  }
  componentWillReceiveProps(nextProps) {
    const { chimDir, page: nextPage } = nextProps;
    const { page } = this.props;
    if (nextPage !== page) {
      this.props.request(chimDir, nextPage);
    }
  }
  render = () => {
    const { data, loading, failure, render } = this.props;
    const pager = (data && data.data.pager) || [];
    const tracks = (data && data.data.tracks) || [];
    if (loading) {
      return <Spinner animation="border" variant="secondary" />;
    }
    if (!loading && tracks.length === 0) {
      return <div>No tracks posted yet...</div>;
      // render({ tracks: [], pager: { hasMore: false, perPage: 19, total: 0 }, loading, failure });
    }
    return render({ tracks, pager, loading, failure });
  };
}

ChimneyProfileTracksContainer.propTypes = {
  chimDir: PropTypes.string.isRequired,
};

export default CreateContainer(getChimneyProfileTracks, ChimneyProfileTracksContainer);
